<template>
  <div>
    <span><a href="/products">Shop</a> /</span> <span v-html="breadcrumb"></span> <span v-if="isProduct"> {{ currentProduct.name }}</span>
  </div>
</template>
<script>

import {mapState} from 'vuex'
import axios from "axios";

export default {
  el: '#breadcrumb',
  data() {
    return {
      breadcrumb: '',
      isProduct: window.location.href.includes("/product/"),
      name: '',
      slug: '',
      url: '/products/'
    }
  },
  computed: {
    ...mapState(["currentProduct", "currentSlug"]),
  },
  methods: {
    buildBreadcrumb(slug) {
      slug.forEach(crumb => {
        this.url += crumb + '/';
        crumb = crumb.replace(/-/g, ' ');
        crumb = crumb.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
        this.breadcrumb += '<a href="'+this.url+'">' + crumb + '</a> / ';
      })
    },

    async doBreadcrumb() {
      // if category page, then just use current category, only dynamic for product page
      if(window.location.href.includes("/products/")) {
        this.slug = window.location.pathname.split("/");
        this.slug.shift();
        this.slug.shift();
        this.slug.pop();
        this.buildBreadcrumb(this.slug);
      }

      if(window.location.href.includes("/product/")) {
        if (window.location.href.includes("?search=true")) {
          await this.getDefaultSlug();
          this.slug = this.slug.split("/");
        } else if(this.$store.state.currentSlug) {
          this.slug = this.$store.state.currentSlug.split("/");
        } else {
          await this.getDefaultSlug();
          this.slug = this.slug.split("/");
        }
        this.buildBreadcrumb(this.slug);
      }

    },

    async getDefaultSlug() {
      let form_data = new FormData;
      form_data.append('action', 'yodah_breadcrumb_query');
      form_data.append('category', this.$store.state.currentProduct.category_id);
      await axios.post(my_ajax_object.ajax_url, form_data)
          .then(response => {
            this.slug = response.data.data.toString();
          }).catch(error => {
        console.log('there was a problem...', error);
      })
    }
  },
  mounted() {
    this.doBreadcrumb();
  }
};
</script>